// extracted by mini-css-extract-plugin
export default {"whatWeDoForTheEnvironment":"whatWeDoForTheEnvironment_whatWeDoForTheEnvironment__QpkBi","featureWrap":"whatWeDoForTheEnvironment_featureWrap__5quMu"};